const LoginBackgroundType = {
  image: "image",
  color: "color",
};
export default LoginBackgroundType;
